import MuiAccordion from './MuiAccordion';
import MuiAlert from './MuiAlert';
import MuiAutocomplete from './MuiAutocomplete';
import MuiBadge from './MuiBadge';
import MuiButton from './MuiButton';
import MuiCard from './MuiCard';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import MuiContainer from './MuiContainer';
import MuiCssBaseline from './MuiCssBaseline';
import MuiDialog from './MuiDialog';
import MuiDrawer from './MuiDrawer';
import MuiFilledInput from './MuiFilledInput';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiList from './MuiList';
import MuiListItemButton from './MuiListItemButton';
import MuiPaper from './MuiPaper';
import MuiTextField from './MuiTextField';
import MuiToggleButton from './MuiToggleButton';
import MuiToggleButtonGroup from './MuiToggleButtonGroup';
import MuiTooltip from './MuiTooltip';
import MuiSnackbarContent from './MuiSnackbarContent';

const MuiOverrides = {
  components: {
    ...MuiAccordion,
    ...MuiAlert,
    ...MuiAutocomplete,
    ...MuiBadge,
    ...MuiButton,
    ...MuiCard,
    ...MuiCheckbox,
    ...MuiChip,
    ...MuiContainer,
    ...MuiCssBaseline,
    ...MuiDialog,
    ...MuiDrawer,
    ...MuiFilledInput,
    ...MuiFormControlLabel,
    ...MuiList,
    ...MuiListItemButton,
    ...MuiPaper,
    ...MuiTextField,
    ...MuiToggleButton,
    ...MuiToggleButtonGroup,
    ...MuiTooltip,
    ...MuiSnackbarContent,
  },
};

export default MuiOverrides;
